import React from "react";

export default function TinyCharts() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_872_534)">
        <circle cx="22" cy="22" r="18" fill="#EAEEF9" />
      </g>
      <path
        d="M22 4C25.0798 4 28.1081 4.79022 30.7952 6.29507C33.4823 7.79992 35.7383 9.96907 37.3475 12.595C38.9567 15.221 39.8652 18.2159 39.9861 21.2933C40.107 24.3707 39.4363 27.4277 38.0381 30.1718C36.6399 32.9159 34.561 35.2554 32.0003 36.9664C29.4395 38.6775 26.4826 39.7029 23.4123 39.9445C20.342 40.1861 17.261 39.636 14.4641 38.3466C11.6672 37.0572 9.24795 35.0717 7.4377 32.5801L22 22V4Z"
        fill="url(#paint0_linear_872_534)"
      />
      <defs>
        <filter
          id="filter0_i_872_534"
          x="4"
          y="4"
          width="36"
          height="38"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.211765 0 0 0 0 0.168627 0 0 0 0 0.45098 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_872_534"
          />
        </filter>
        <linearGradient
          id="paint0_linear_872_534"
          x1="22"
          y1="-14"
          x2="-14"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32C5FF" />
          <stop offset="0.512584" stopColor="#B620E0" />
          <stop offset="1" stopColor="#F7B500" />
        </linearGradient>
      </defs>
    </svg>
  );
}
